/***************************************************************************************************
** isObjectEmpty
***************************************************************************************************/

export default function isObjectEmpty(obj) {
  return (Object.values(obj).filter((value) => (value)).length === 0);
}
